import api from '../../../../../core/api.js';

export const ModalSelector = {
  TITLE: api.internals.ns.selector('modal__title')
};
